import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import StaffPortal from "@/pages/StaffPortal";
import AdminDashboard from "@/pages/AdminDashboard";
import DashboardPage from "@/pages/DashboardPage";
import LeavePage from "@/pages/LeavePage";
import SettingsPage from "@/pages/SettingsPage";
import SchedulePage from "@/pages/SchedulePage";
import ChannelsPage from "@/pages/ChannelsPage";
import TasksPage from "@/pages/TasksPage";
import PerformancePage from "@/pages/PerformancePage";
import YearlyPage from "@/pages/YearlyPage";
import ReportsPage from "@/pages/ReportsPage";
import PartnersPage from "@/pages/PartnersPage";
import PropertyRegistryPage from "@/pages/PropertyRegistryPage";
import SignContractPage from "@/pages/SignContractPage";
import RateSimulatorPage from "@/pages/RateSimulatorPage";
import ReservationReportPage from "@/pages/ReservationReportPage";
import ChannelChecklistPage from "@/pages/ChannelChecklistPage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/sign/:token" element={<SignContractPage />} />
            <Route path="/staff" element={<ProtectedRoute role="staff"><StaffPortal /></ProtectedRoute>} />
            <Route path="/staff/dashboard" element={<ProtectedRoute role="staff"><DashboardPage /></ProtectedRoute>} />
            <Route path="/staff/leave" element={<ProtectedRoute role="staff"><LeavePage /></ProtectedRoute>} />
            <Route path="/staff/schedule" element={<ProtectedRoute role="staff"><SchedulePage /></ProtectedRoute>} />
            <Route path="/staff/channels" element={<ProtectedRoute role="staff"><ChannelsPage /></ProtectedRoute>} />
            <Route path="/staff/tasks" element={<ProtectedRoute role="staff"><TasksPage /></ProtectedRoute>} />
            <Route path="/staff/performance" element={<ProtectedRoute role="staff"><PerformancePage /></ProtectedRoute>} />
            <Route path="/staff/yearly" element={<ProtectedRoute role="staff"><YearlyPage /></ProtectedRoute>} />
            <Route path="/staff/reports" element={<ProtectedRoute role="staff"><ReportsPage /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/dashboard" element={<ProtectedRoute role="admin"><DashboardPage /></ProtectedRoute>} />
            <Route path="/admin/leave" element={<ProtectedRoute role="admin"><LeavePage /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute role="admin"><SettingsPage /></ProtectedRoute>} />
            <Route path="/admin/schedule" element={<ProtectedRoute role="admin"><SchedulePage /></ProtectedRoute>} />
            <Route path="/admin/channels" element={<ProtectedRoute role="admin"><ChannelsPage /></ProtectedRoute>} />
            <Route path="/admin/tasks" element={<ProtectedRoute role="admin"><TasksPage /></ProtectedRoute>} />
            <Route path="/admin/performance" element={<ProtectedRoute role="admin"><PerformancePage /></ProtectedRoute>} />
            <Route path="/admin/yearly" element={<ProtectedRoute role="admin"><YearlyPage /></ProtectedRoute>} />
            <Route path="/admin/reports" element={<ProtectedRoute role="admin"><ReportsPage /></ProtectedRoute>} />
            <Route path="/admin/partners" element={<ProtectedRoute role="admin"><PartnersPage /></ProtectedRoute>} />
            <Route path="/admin/partner-properties" element={<ProtectedRoute role="admin"><PropertyRegistryPage /></ProtectedRoute>} />
            <Route path="/admin/rate-simulator" element={<ProtectedRoute role="admin"><RateSimulatorPage /></ProtectedRoute>} />
            <Route path="/admin/channel-checklist" element={<ProtectedRoute role="admin"><ChannelChecklistPage /></ProtectedRoute>} />
            <Route path="/staff/channel-checklist" element={<ProtectedRoute role="staff"><ChannelChecklistPage /></ProtectedRoute>} />
            <Route path="/staff/rate-simulator" element={<ProtectedRoute role="staff"><RateSimulatorPage /></ProtectedRoute>} />
            <Route path="/admin/reservation-report" element={<ProtectedRoute role="admin"><ReservationReportPage /></ProtectedRoute>} />
            <Route path="/staff/reservation-report" element={<ProtectedRoute role="staff"><ReservationReportPage /></ProtectedRoute>} />
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
